<template>
  <div class="wrap">
    <div class="main_img">
      <img src="https://kr.object.ncloudstorage.com/mailpad/2024-03/240304_sk.png" usemap="#Map" border="0" />
      <ul class="top">
        <li>
          <a href="https://apply.carrotenglish.net/start?idx=132294" target="_blank"></a>
        </li>
        <li>
          <a href="http://apply.imooc.co.kr/start/skbiosc" target="_blank"></a>
        </li>
      </ul>

      <ul class="bottom">
        <li>
          <a href="http://apply.imooc.co.kr/start/skbiow" target="_blank"></a>
        </li>
        <li>
          <a href="http://apply.imooc.co.kr/start/skbios" target="_blank"></a>
        </li>
      </ul>

      <!-- <map name="Map">
        <area shape="rect" coords="42,1267,383,1342" href="https://apply.carrotenglish.net/start?idx=132241" target="_blank" />

        <area shape="rect" coords="416,1263,748,1348" href="http://apply.imooc.co.kr/start/skbiosc" target="_blank" />

        <area shape="rect" coords="44,1350,385,1435" href="http://apply.imooc.co.kr/start/skbiow" target="_blank" />

        <area shape="rect" coords="421,1352,747,1433" href="http://apply.imooc.co.kr/start/skbios" target="_blank" />
      </map> -->
    </div>
  </div>
</template>

<script>
export default {
  methods: {},
  mounted() {},
};
</script>

<style lang="scss" scoped></style>
<style lang="scss">
.wrap {
  text-align: center;
  .main_img {
    position: relative;
    max-width: 800px;
    margin: 0 auto;

    .top {
      position: absolute;
      left: 0;
      bottom: 12%;
      width: 100%;
      height: 3%;
      background: transparent;
      margin: 0 auto;
      display: grid;
      grid-template-columns: repeat(2, 1fr);

      li a {
        display: block;
        width: 100%;
        height: 100%;
      }
    }

    .bottom {
      position: absolute;
      left: 0;
      bottom: 6%;
      width: 100%;
      height: 3%;
      margin: 0 auto;
      background: transparent;
      display: grid;
      grid-template-columns: repeat(2, 1fr);

      @media screen and (min-width: 455px) {
        bottom: 6%;
      }

      @media screen and (min-width: 700px) {
        bottom: 7%;
      }

      li a {
        display: block;
        width: 100%;
        height: 100%;
      }
    }

    img {
      width: 100%;
    }
  }
}

.menu {
  display: none;
}

#nav {
  display: none;
}
</style>
